// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-mobileGenInfo .rDNA-button, .rDNA-mobileGenInfo .rDNA-mobileImgBox {
  display: flex;
  flex-direction: column;
}

.rDNA-mobileGenInfo .rDNA-mobileGenTopRow, .rDNA-mobileGenInfo .rDNA-smBtnBox {
  display: flex;
  flex-direction: row;
}

.rDNA-mobileGenInfo .rDNA-button, .rDNA-mobileGenInfo .rDNA-mobileImgBox {
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-mobileGenInfo .rDNA-Txt {
  font-family: "Dm Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-mobileGenInfo .rDNA-button {
  font-family: "Dm Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-mobileGenInfo .rDNA-title {
  font-family: "Dm Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-mobileGenInfo {
  background: #fff;
  padding: 20px 10px 10px;
  margin-bottom: 10px;
}
.rDNA-mobileGenInfo .rDNA-socialWrapper {
  padding: 0 15px;
}
.rDNA-mobileGenInfo .export-btn {
  border: 1px solid #1B3E78;
}
.rDNA-mobileGenInfo .rDNA-mobileGenLogo {
  position: relative !important;
}
.rDNA-mobileGenInfo .rDNA-mobileGenTopRow {
  margin-bottom: 20px;
}
.rDNA-mobileGenInfo .rDNA-mobileImgBox {
  position: relative;
  border-radius: 15px;
  width: 150px;
  height: 150px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  margin-right: 20px;
}
.rDNA-mobileGenInfo .rDNA-title {
  margin-top: 10px;
  color: #A3AED0;
  margin-bottom: 5px;
}
.rDNA-mobileGenInfo .rDNA-Txt {
  color: #1B3E78;
  margin-bottom: 25px;
}
.rDNA-mobileGenInfo .rDNA-mobileImgConstrainer {
  width: 150px;
  background: #fff;
  border-radius: 10px;
}
.rDNA-mobileGenInfo .rDNA-button {
  border-radius: 5px;
  flex: 1;
  height: 25px;
}
.rDNA-mobileGenInfo .rDNA-button span {
  margin-left: 10px;
}
.rDNA-mobileGenInfo .share-btn {
  color: #fff;
  background: #1B3E78;
  margin-right: 20px;
}
.rDNA-mobileGenInfo .compare-btn {
  color: #fff;
  background: #0CAD99;
  height: 35px;
  width: 100%;
  margin: 10px 20px 10px 0;
}

.socials-overlay {
  position: relative; /* Ensure the overlay is positioned relative to this container */
  width: 100%; /* Ensure it takes full width */
  height: auto; /* Adjust height as needed */
}

.logo-container {
  width: 50vw; /* Ensure it takes full width */
  height: auto;
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/profiles/dashboard/elements/mobile-company-general-info/mobile-company-general-info.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EAC0B,aAAA;EACA,sBAAA;ACA1B;;ADGA;EAC0B,aAAA;EACA,mBAAA;ACA1B;;ADGA;EAC0B,uBAAA;EACA,mBAAA;ACA1B;;ACbA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADgBF;ACbA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADeF;ACZA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADcF;ACXA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADaF;ACVA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADYF;ACTA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADWF;ACRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADUF;ACPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADSF;ACNA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADQF;ACLA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADOF;ACJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADIF;ACDA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADGF;ACAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADEF;ACCA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADCF;ACEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADAF;ACGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADDF;AEnHA;;;;;uBAAA;ACaA;ECJE,kCFXY;EEYZ,eDG2C;ECF3C,gBATiF;EAUjF,kBALgB;AJwHlB;;AG7FA;ECzBE,kCFXY;EEYZ,eDwB2C;ECvB3C,gBAXqF;EAYrF,kBALgB;AJ+HlB;;AGnGA;EC1BE,kCFXY;EEYZ,eDyB2C;ECxB3C,gBAXqF;EAYrF,kBALgB;AJsIlB;;ACpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADuJF;ACpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADsJF;ACnJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADqJF;AClJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADoJF;ACjJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADmJF;AChJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADkJF;AC/IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADiJF;AC9IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADgJF;AC7IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AD+IF;AC5IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AD8IF;AC3IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AD6IF;AC1IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AD4IF;ACzIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AD2IF;ACxIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AD0IF;ACvIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADyIF;ACtIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADwIF;ACrIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADuIF;ACpIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADsIF;AE1PA;;;;;uBAAA;AFAA;EACwC,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkQxC;AAhQE;EAAwC,eAAA;AAmQ1C;AAlQE;EAAwC,yBAAA;AAqQ1C;AApQE;EAAwC,6BAAA;AAuQ1C;AArQE;EAEwC,mBAAA;AAsQ1C;AApQE;EAC0C,kBAAA;EAGA,mBAnBxB;EAoBwB,YArB1B;EAsB0B,aAtB1B;EAuB0B,2CAAA;EACA,kBAAA;AAoQ5C;AAlQE;EAC0C,gBAAA;EACA,cEf5B;EFgB4B,kBAAA;AAoQ5C;AAjQE;EAC0C,cEtBhC;EFwBgC,mBAAA;AAkQ5C;AAhQE;EAC0C,YAtC1B;EAwC0B,gBAAA;EACA,mBAAA;AAiQ5C;AA/PE;EAC0C,kBAAA;EACA,OAAA;EACA,YAAA;AAiQ5C;AA7P4C;EAAO,iBAAA;AAgQnD;AA9PE;EAC0C,WEzC/B;EF0C+B,mBE3ChC;EF4CgC,kBAAA;AAgQ5C;AA9PE;EAC0C,WE9C/B;EF+C+B,mBEjD/B;EFkD+B,YAAA;EACA,WAAA;EACA,wBAAA;AAgQ5C;;AA5PA;EACE,kBAAA,EAAA,gEAAA;EACA,WAAA,EAAA,+BAAA;EACA,YAAA,EAAA,4BAAA;AA+PF;;AA5PA;EACE,WAAA,EAAA,+BAAA;EACA,YAAA;AA+PF;;AA5PA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AA8PF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import 'placeholders/flexboxes';\n@import 'placeholders/fonts';\n@import 'variables';\n\n$img-dimensional: 150px;\n$img-border-radius: 15px;\n\n.rDNA-mobileGenInfo                   {\n                                        background: #fff;\n                                        padding: 20px 10px 10px;\n                                        margin-bottom: 10px;\n\n  .rDNA-socialWrapper                   { padding: 0 15px; }\n  .export-btn                           { border: 1px solid $dark-text; }\n  .rDNA-mobileGenLogo                   { position: relative !important;}\n  .rDNA-smBtnBox                        { @extend %flex-row; }\n  .rDNA-mobileGenTopRow                 {\n                                          @extend %flex-row;\n                                          margin-bottom: 20px;\n                                        }\n  .rDNA-mobileImgBox                    {\n                                            position: relative; // Ensure the box is positioned relative for absolute positioning of overlay\n                                            @extend %flex-column;\n                                            @extend %flex-jCenter-aCenter;\n                                            border-radius: $img-border-radius;\n                                            width: $img-dimensional;\n                                            height: $img-dimensional;\n                                            box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);\n                                            margin-right: 20px;\n                                          }\n  .rDNA-title                           {\n                                            margin-top: 10px;\n                                            color: $inactive-text;\n                                            margin-bottom: 5px;\n                                            @extend %font-12px-medium;\n                                          }\n  .rDNA-Txt                             {\n                                            color: $dark-text;\n                                            @extend %font-16px-bold;\n                                            margin-bottom: 25px;\n                                          }\n  .rDNA-mobileImgConstrainer            {\n                                            width: $img-dimensional;\n                                            //height: $img-dimensional;\n                                            background: #fff;\n                                            border-radius: 10px;\n                                          }\n  .rDNA-button                          {\n                                            border-radius: 5px;\n                                            flex: 1;\n                                            height: 25px;\n                                            @extend %font-14px-medium;\n                                            @extend %flex-column;\n                                            @extend %flex-jCenter-aCenter;\n                                            span { margin-left: 10px; }\n                                          }\n  .share-btn                            {\n                                            color: $light-text;\n                                            background: $dark-text;\n                                            margin-right: 20px;\n                                          }\n  .compare-btn                          {\n                                            color: $light-text;\n                                            background: $accent-btn;\n                                            height: 35px;\n                                            width: 100%;\n                                            margin: 10px 20px 10px 0;\n                                          }\n}\n\n.socials-overlay {\n  position: relative; /* Ensure the overlay is positioned relative to this container */\n  width: 100%; /* Ensure it takes full width */\n  height: auto; /* Adjust height as needed */\n}\n\n.logo-container {\n  width: 50vw; /* Ensure it takes full width */\n  height: auto;\n}\n\n.edit-overlay {\n  position: absolute; // Position the overlay absolutely\n  top: 0; // Cover the top\n  left: 0; // Cover the left\n  right: 0; // Cover the right\n  bottom: 0; // Cover the bottom\n\n  display: flex; // Center content if needed\n  justify-content: center; // Center horizontally\n  align-items: center; // Center vertically\n  z-index: 10; // Ensure it appears above other elements\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
